import { render, staticRenderFns } from "./pointdialog.vue?vue&type=template&id=3bddaee5&scoped=true&"
import script from "./pointdialog.vue?vue&type=script&lang=js&"
export * from "./pointdialog.vue?vue&type=script&lang=js&"
import style0 from "./pointdialog.vue?vue&type=style&index=0&id=3bddaee5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bddaee5",
  null
  
)

export default component.exports